import { AppDispatch } from "../../dataManagement/uiDb/UiDb";
import { profileUpdate } from "../thunks/ProfileThunk";
import { UserProfile } from "../../interfaces/UserObject";

/**
 * Saves only the address field, preserving all other profile data unchanged.
 * Spreads the current profile and overrides address before dispatching profileUpdate.
 */
export async function saveAddressOnly(
  dispatch: AppDispatch,
  currentProfile: UserProfile,
  newAddress: string
): Promise<void> {
  await dispatch(profileUpdate({ ...currentProfile, address: newAddress })).unwrap();
}
